import { useState } from 'react';
import type { PublishingSetting } from '../publishingApi';
import { field, button, channelLabel } from './publishingUi';
export function Setting({
  setting,
  account,
  canWrite,
  busy,
  save,
}: {
  setting: PublishingSetting;
  account?: { connected: boolean; targetId?: string; error: string | null };
  canWrite: boolean;
  busy: boolean;
  save: (patch: { defaultTime?: string; paused?: boolean }) => void;
}) {
  const [time, setTime] = useState(setting.defaultTime);
  return (
    <article className="rounded border border-white/15 p-3">
      <h3 className="font-semibold">{channelLabel(setting.id)}</h3>
      <p className="my-2 break-all text-xs">
        {account
          ? account.connected
            ? `Verbunden · ${account.targetId}`
            : account.error
          : 'Verbindung noch nicht geprüft'}
      </p>
      <label className="text-sm">
        Standardzeit
        <input
          className={field}
          type="time"
          value={time}
          disabled={!canWrite}
          onChange={(e) => setTime(e.target.value)}
        />
      </label>
      {canWrite && (
        <div className="mt-2 flex flex-wrap gap-2">
          <button
            className={button}
            disabled={busy || time === setting.defaultTime || !time}
            onClick={() => save({ defaultTime: time })}
          >
            Zeit speichern
          </button>
          <button className={button} disabled={busy} onClick={() => save({ paused: !setting.paused })}>
            {setting.paused ? 'Kanal fortsetzen' : 'Kanal pausieren'}
          </button>
        </div>
      )}
    </article>
  );
}
